import { CoralogixRum, CoralogixLogSeverity } from '@coralogix/browser';
import envConfig from '@nile/home/src/Config/env';

export const initializeCoralogixRUM = (dcRegion, coralogixRumPublicKey) => {
  try {
    // Get Coralogix configuration from environment config
    const {
      coralogixApplicationName: CORALOGIX_APPLICATION_NAME,
      coralogixSubsystemName: CORALOGIX_SUBSYSTEM_NAME,
      coralogixAppVersion: CORALOGIX_APP_VERSION
      // coralogixDomain: CORALOGIX_DOMAIN
    } = envConfig;

    if (!coralogixRumPublicKey) {
      console.warn(
        'Coralogix RUM Public Key not set. RUM will not be initialized.'
      );
      return;
    }

    // Determine environment based on current configuration
    const environment = envConfig.mode;

    console.log('Initializing Coralogix RUM with environment:', environment);

    CoralogixRum.init({
      public_key: coralogixRumPublicKey,
      application: CORALOGIX_APPLICATION_NAME,
      version: CORALOGIX_APP_VERSION,
      coralogixDomain: dcRegion,
      // user_context: {
      //   user_email: 'user@example.com', // Optional: User-specific context
      //   user_name: 'Example User',
      //   user_id: 'user-123'
      // },
      labels: {
        environment: environment, // Dynamic environment detection
        team: 'frontend',
        subsystem: CORALOGIX_SUBSYSTEM_NAME // Add subsystem as a custom label
      },
      // Add debug configuration to reduce verbose logging
      debug: false, // Disable debug mode to reduce internal logs
      // Further configurations:
      instrumentations: {
        xhr: false, // Capture XHR requests
        fetch: false, // Capture Fetch requests
        web_vitals: envConfig.mode === 'alpha', // Capture Web Vitals (LCP, FID, CLS)
        errors: false, // Capture unhandled errors
        interactions: false, // Capture user interactions (clicks)
        long_tasks: false,
        resources: false
      },
      sessionRecordingConfig: {
        enable: false, // Set to true to enable session recording (requires additional setup/cost)
        autoStartSessionRecording: false
      },
      ignoreErrors: [
        /ResizeObserver loop limit exceeded/, // Example: Ignore common browser errors
        'Network error message to ignore'
      ],
      ignoreUrls: [
        /google-analytics\.com/ // Example: Ignore certain network requests
      ]
    });

    console.log('Coralogix RUM initialized successfully');

    // Example of setting/updating user context later if needed
    // CoralogixRum.setUserContext({
    //   user_email: 'updated.user@example.com',
    // });
  } catch (error) {
    console.error('Failed to initialize Coralogix RUM:', error);
  }
};

export const sendTestLog = () => {
  try {
    CoralogixRum.log(
      CoralogixLogSeverity.Info,
      'Application started - RUM initialized',
      //    {samplejson: 'This is a test log for Coralogix RUM'},
      {
        environment: envConfig.mode,
        // timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent
      }
    );
    console.log('Test log sent to Coralogix');
  } catch (error) {
    console.error('Failed to send test log to Coralogix:', error);
  }
};

// Utility functions for common Coralogix operations
export const loggerInfo = (message, data = {}) => {
  try {
    CoralogixRum.log(CoralogixLogSeverity.Info, message, {
      ...data,
      // timestamp: new Date().toISOString(),
      environment: envConfig.mode
    });
  } catch (error) {
    console.error('Failed to log info to Coralogix:', error);
  }
};

// Generic logging function with custom severity
export const coralogixLogWithSeverity = (severity, message, data = {}) => {
  try {
    CoralogixRum.log(severity, message, {
      ...data,
      timestamp: new Date().toISOString(),
      environment: envConfig.mode
    });
  } catch (error) {
    console.error('Failed to log to Coralogix:', error);
  }
};
